var map = {
	"./apple.png": 1208,
	"./devices.png": 481,
	"./devices@2x.png": 1209,
	"./devices@3x.png": 1210,
	"./icon-chat.png": 1211,
	"./icon-doc.png": 1212,
	"./icon-pro.png": 1213,
	"./icon-w2.png": 1214,
	"./logo-blue.png": 482,
	"./logo-businessinsider.png": 1215,
	"./logo-forbes.png": 1216,
	"./logo-icon.png": 483,
	"./logo-macworld.png": 1217,
	"./logo-venturebeat.png": 1218,
	"./logo-yahoo.png": 1219,
	"./logo.png": 1220,
	"./logo@2x.png": 1221,
	"./ornament-left-white.png": 1222,
	"./ornament-left.png": 484,
	"./ornament-right-white.png": 1223,
	"./ornament-right.png": 485,
	"./step1.png": 486,
	"./step2.png": 487,
	"./step3.png": 488
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1594;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img ^\.\/.*\.png$
// module id = 1594
// module chunks = 0